class Auth {
    constructor() {
        this.facebook = null;
        this.google = false;
    }

    openCreate(allowInstant = false) {
        app.analytics.track("create_user_shown");
        // if (allowInstant) {
        //     app.ajax.post('/services/user/auth/instant');
        // } else {
        //     app.ajax.modalClear('/services/layout/element/user/create', 'create');
        // }

        app.ajax.modalClear('/services/layout/element/user/create', 'create');
    }

    openLogin() {
        app.analytics.track("login_user_shown");
        app.ajax.modalClear('/services/layout/element/user/login', 'login');
    }

    register(form, onSuccess) {
        app.analytics.track("create_user_standard");
        app.form.post(form, "/services/user/auth/register", onSuccess);
        return true;
    }

    login(form) {
        app.analytics.track("login_user_standard");
        app.form.post(form, "/services/user/auth/login", function () {
            window.location.reload();
        });
        return true;
    }

    loginWithAcceptTerms(code) {
        this.acceptTermsAndLogin(code, function () {
            window.location.reload();
        });
    }

    loginWithAcceptTermsDialog(header, body, positiveText, negativeText, code) {
        app.analytics.track("terms_dialog_shown");
        app.alert.dialog(header, body, positiveText, () => app.auth.loginWithAcceptTerms(code), negativeText);
    }

    sendResetPassword(form) {
        app.analytics.track("request_password_reset");
        app.form.post(form, "/send/recovery", function () {
            setTimeout(function () {
                app.auth.openLogin();
            }, 1700);
        });
    }

    resetPassword(form, code) {
        app.analytics.track("password_reset");
        app.form.post(form, "/recovery/" + code, function () {
            setTimeout(function () {
                app.ajax.inject("/", "#page");
                app.auth.openLogin();
            }, 1700);
        });
    }


    acceptTerms(code, onSuccess) {
        app.analytics.track("accept_terms");
        app.ajax.post("/accept-terms/" + code, {}, function () {
            onSuccess();
        });
    }

    acceptTermsAndLogin(code, onSuccess) {
        app.analytics.track("accept_terms");
        app.ajax.post("/accept-terms-login/" + code, {}, function () {
            app.analytics.userLogin();
            onSuccess();
        });
    }

    logout() {
        app.ajax.post("/services/user/auth/logout", {}, function () {
            window.location = "/";
            app.analytics.userLogout();
        });
    }

    getThirdPartyCreateOptions(type) {
        let eula = false;
        let ace = false;
        let username = null;
        let email = null;
        let password = null;

        if ($("#content-profile").length) {
            eula = true;
        } else {
            $("[name='eula']").each(function () {
                if (this.checked) {
                    eula = true;
                }
            });
        }
        $("[name='accept_campaign_emails']").each(function () {
            if (this.checked) {
                ace = true;
            }
        });
        let input = $("[name='username']").val();
        if (input) {
            username = input;
        }
        input = $("[name='email']").val();
        if (input) {
            email = input;
        }
        input = $("[name='password']").val();
        if (input) {
            password = input;
        }

        return {eula: eula, ace: ace, username: username, email: email, password: password, type: type}
    }

    facebookLogin(type) {
        app.analytics.track("facebook_user_" + type);
        if (!this.facebook) {
            this.facebook = new Facebook(app.config['fbId']);
        }
        this.facebook.login(type);
    }

    facebookLoginWithAcceptTerms(code) {
        this.acceptTerms(code, function () {
            app.auth.facebookLogin();
        });
    }

    googleLogin(type) {
        app.analytics.track("google_user_" + type);
        if (!this.google) {
            this.google = true;
            google.accounts.id.initialize({
                client_id: app.config.googleId,
                callback: (resp) => {
                    app.ajax.post("/services/user/auth/google", {
                        "resp": resp,
                        "type": type,
                        "co": app.auth.getThirdPartyCreateOptions()
                    }, (data) => {
                        if (type === "fill") {
                            this.fillWizard(data);
                        }
                    });
                },
                use_fedcm_for_prompt: true
            });
        }
        setTimeout(function () {
            google.accounts.id.prompt();
        }, 100);
    }

    googleRedirect() {
        app.ajax.post("/services/user/auth/google", {
            "resp": resp,
            "type": type,
            "co": app.auth.getThirdPartyCreateOptions()
        });
    }

    googleLoginWithAcceptTerms(code) {
        this.acceptTermsAndLogin(code, () => window.location = "/me/edit");
    }

    steamLogin(url, type) {
        app.analytics.track("steam_user_login");
        let w = Math.min(1000, screen.width);
        let h = Math.min(800, screen.height);
        const left = ((screen.width / 2) - (w / 2));
        const top = ((screen.height / 2) - (h / 2));
        app.util.setCookie("cred", JSON.stringify(this.getThirdPartyCreateOptions(type)), 900);
        app.util.setCookie("steam_cred", "waiting", 900);
        window.open(url, "Steam login", "location=no,menubar=no,scrollbars=no,status=no,width=" + w + ",height=" + h + ",top=" + top + ",left=" + left);
        if (type === "fill") {
            window.steamLoginInterval = setInterval(() => {
                if (app.util.getCookie("steam_cred") === "") {
                    clearInterval(window.steamLoginInterval);
                    app.ajax.post("/services/user/auth/fetch", {name: "steam_cred"}, (data) => {
                        this.fillWizard(JSON.parse(data.value));
                        app.util.deleteCookie("steam_cred");
                    });
                }
            }, 1000);
        }
    }

    discordLogin(url, type) {
        app.analytics.track("discord_user_login");
        let w = Math.min(1000, screen.width);
        let h = Math.min(800, screen.height);
        const left = ((screen.width / 2) - (w / 2));
        const top = ((screen.height / 2) - (h / 2));
        app.util.setCookie("cred", JSON.stringify(this.getThirdPartyCreateOptions(type)), 900);
        app.util.setCookie("discord_cred", "waiting", 900);
        window.open(url, "Discord login", "location=no,menubar=no,scrollbars=no,status=no,width=" + w + ",height=" + h + ",top=" + top + ",left=" + left);
        if (type === "fill") {
            window.discordLoginInterval = setInterval(() => {
                if (app.util.getCookie("discord_cred") === "") {
                    clearInterval(window.discordLoginInterval);
                    app.ajax.post("/services/user/auth/fetch", {name: "discord_cred"}, (data) => {
                        this.fillWizard(JSON.parse(data.value));
                        app.util.deleteCookie("discord_cred");
                    });
                }
            }, 1000);
        }
    }

    removeRandomPassword() {
        $(".random_password").slideUp(200);
    }

    getRandomUsername() {
        app.analytics.track("user_get_random_username");
        app.ajax.get("/generate/random/username", {}, (data) => {
            $("#new-username").val(data.username);
        });
    }

    getRandomPassword() {
        app.analytics.track("user_get_random_password");
        app.ajax.get("/generate/random/password", {}, (data) => {
            const wrapper = $(".random_password");
            wrapper.find("div").html(data.password);
            $("#new-password").val(data.password);
            wrapper.slideDown(200);
        });
    }

    fillWizard(data) {
        for (let i in data) {
            if (i === "fb_id") {
                $("#facebook-login-small .checkmark").slideDown(200);
            }
            if (i === "go_id") {
                $("#google-login-small .checkmark").slideDown(200);
            }
            if (i === "st_id") {
                $("#steam-login-small .checkmark").slideDown(200);
            }
            if (i === "di_id") {
                $("#discord-login-small .checkmark").slideDown(200);
            }
            $("[name='" + i + "']").val(data[i]);
        }
    }

    selectProfileImage(el, filename) {
        $("#profile_images .glow").removeClass("glow");
        $(el).addClass("glow");
        $("#profile_image").val(filename);
    }

    selectBackgroundImage(el, filename) {
        $("#background_images .glow").removeClass("glow");
        $(el).addClass("glow");
        $("#background_image").val(filename);
    }
}